define("calendar/components/calendar/settings/time-zone", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="u--row">
    <div class="u--col__4">
      <h5
        class="u--text--md u--m__t__0 qa--displaySettings_language_title"
        data-test-id="calendar-settings-timezone-title"
      >
        {{t "calendar.settings.timezone_title"}}
      </h5>
    </div>
    <div class="u--col__8">
      <form class="o--formWrapper u--m__b__sm">
        <select class="o--form__select" {{on "change" this.setTimeZone}}>
          {{#each this.allTimeZones as |timeZone|}}
            <option selected={{are-equal timeZone.name this.currentSetTimeZone}} value={{timeZone.name}}>
              {{timeZone.name}}
            </option>
          {{/each}}
        </select>
      </form>
      <p class="u--text--light">{{t "calendar.settings.timezone_detail"}}</p>
    </div>
  </div>
  */
  {
    "id": "/b+ZavkL",
    "block": "[[[10,0],[14,0,\"u--row\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n    \"],[10,\"h5\"],[14,0,\"u--text--md u--m__t__0 qa--displaySettings_language_title\"],[14,\"data-test-id\",\"calendar-settings-timezone-title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"calendar.settings.timezone_title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n    \"],[10,\"form\"],[14,0,\"o--formWrapper u--m__b__sm\"],[12],[1,\"\\n      \"],[11,\"select\"],[24,0,\"o--form__select\"],[4,[38,1],[\"change\",[30,0,[\"setTimeZone\"]]],null],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"allTimeZones\"]]],null]],null],null,[[[1,\"          \"],[10,\"option\"],[15,\"selected\",[28,[37,4],[[30,1,[\"name\"]],[30,0,[\"currentSetTimeZone\"]]],null]],[15,2,[30,1,[\"name\"]]],[12],[1,\"\\n            \"],[1,[30,1,[\"name\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--light\"],[12],[1,[28,[35,0],[\"calendar.settings.timezone_detail\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"timeZone\"],false,[\"t\",\"on\",\"each\",\"-track-array\",\"are-equal\"]]",
    "moduleName": "calendar/components/calendar/settings/time-zone.hbs",
    "isStrictMode": false
  });
  let TimeZoneComponent = _exports.default = (_dec = (0, _service.inject)('calendar/config'), (_class = class TimeZoneComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "calendarConfig", _descriptor3, this);
      _initializerDefineProperty(this, "errors", _descriptor4, this);
      _initializerDefineProperty(this, "intl", _descriptor5, this);
      _initializerDefineProperty(this, "segment", _descriptor6, this);
      _initializerDefineProperty(this, "userConfig", _descriptor7, this);
    }
    get allTimeZones() {
      return this.userConfig.timezones;
    }
    get currentSetTimeZone() {
      return this.userConfig.currentTimeZone?.name || this.auth.currentUserModel.timeZone;
    }
    setTimeZone(_ref) {
      let {
        target: {
          value
        }
      } = _ref;
      const timeZone = this.allTimeZones?.find(zone => zone.name === value);
      if (!timeZone) {
        return this.errors.log('Unable to find time zone.', {
          value,
          allTimeZones: this.allTimeZones
        });
      }
      const {
        name,
        identifier
      } = timeZone;
      this.alerts.success(this.intl.t('alerts.calendar.settings.timezone_change_success.message'), {
        title: this.intl.t('alerts.calendar.settings.timezone_change_success.title')
      });
      (0, _object.set)(this.userConfig, 'currentTimeZone', {
        name,
        identifier
      });
      this.calendarConfig.fullCalendar?.setOption('timeZone', identifier);
      this.segment.track('changed-calendar-timezone', {
        timezone: this.currentSetTimeZone
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "calendarConfig", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setTimeZone", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setTimeZone"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TimeZoneComponent);
});